import { SummaryWrap, SummaryItem } from 'app/common/templates-next/report-template/summary'
import { ReportFinancesDataWriteOffSummary } from 'app/dataTypes/reports/data/common/financesSummaryWriteOff'

type Props = {
  title: string
  total: ReportFinancesDataWriteOffSummary['total']
  currency: string
  pending: boolean
}

export const Summary = ({ total, title, currency, pending }: Props) => {
  const { value } = total
  return (
    <SummaryWrap>
      <SummaryItem title={title} value={`${value} ${currency}`} pending={pending} />
    </SummaryWrap>
  )
}
